import { BillingPeriod } from '@modules/product/billingPeriod';
export const weeklyBillingPeriods = [
    BillingPeriod.Monthly,
    BillingPeriod.Quarterly,
    BillingPeriod.Annual,
];
export const weeklyGiftBillingPeriods = [
    BillingPeriod.Quarterly,
    BillingPeriod.Annual,
];
export function billingPeriodToRatePlan(billingPeriod, isWeeklyGifting) {
    if (isWeeklyGifting) {
        return billingPeriod === BillingPeriod.Annual
            ? 'OneYearGift'
            : 'ThreeMonthGift';
    }
    return billingPeriod.toString();
}
export function getBillingPeriodNoun(billingPeriod, fixedTerm = false) {
    switch (billingPeriod) {
        case BillingPeriod.Annual:
            return fixedTerm ? '12 months' : 'year';
        case BillingPeriod.Quarterly:
            return fixedTerm ? '3 months' : 'quarter';
        case BillingPeriod.OneTime:
            return 'one-time';
        default:
            return 'month';
    }
}
export function getBillingPeriodTitle(billingPeriod, fixedTerm = false) {
    switch (billingPeriod) {
        case BillingPeriod.Annual:
            return fixedTerm ? '12 months' : billingPeriod;
        case BillingPeriod.Quarterly:
            return fixedTerm ? '3 months' : billingPeriod;
        case BillingPeriod.OneTime:
            return 'One-time';
        default:
            return billingPeriod;
    }
}
export function ratePlanToBillingPeriod(ratePlanKey) {
    switch (ratePlanKey) {
        case 'Annual':
        case 'RestOfWorldAnnual':
        case 'DomesticAnnual':
        case 'OneYearGift':
        case 'OneYearStudent':
        case 'V1DeprecatedAnnual':
            return BillingPeriod.Annual;
        case 'ThreeMonthGift':
        case 'Quarterly':
            return BillingPeriod.Quarterly;
        case 'Monthly':
        case 'RestOfWorldMonthly':
        case 'DomesticMonthly':
        case 'Everyday':
        case 'Sixday':
        case 'Weekend':
        case 'Saturday':
        case 'Sunday':
        case 'EverydayPlus':
        case 'SixdayPlus':
        case 'WeekendPlus':
        case 'SaturdayPlus':
        case 'V1DeprecatedMonthly':
            return BillingPeriod.Monthly;
        case 'OneTime':
            return BillingPeriod.OneTime;
    }
    throw new Error('Unsupported rate plan key: ' + ratePlanKey);
}
export function billingPeriodToContributionType(billingPeriod) {
    switch (billingPeriod) {
        case BillingPeriod.OneTime:
            return 'ONE_OFF';
        case BillingPeriod.Monthly:
            return 'MONTHLY';
        case BillingPeriod.Annual:
            return 'ANNUAL';
        default:
            return undefined; // quarterly has no mapping
    }
}
export function toRegularBillingPeriod(regularBillingString) {
    if (!regularBillingString) {
        return undefined;
    }
    // for weeklySubscriptionCheckout (to be deprecated)
    const regularBillingPeriods = [
        BillingPeriod.Annual,
        BillingPeriod.Monthly,
        BillingPeriod.Quarterly,
    ];
    if (regularBillingPeriods.includes(regularBillingString)) {
        return regularBillingString;
    }
    // // for thankyou/checkout mis-matched ratePlan.BillingPeriod (future cleanup)
    if (regularBillingString === 'Quarter') {
        return BillingPeriod.Quarterly;
    }
    if (regularBillingString === 'Month') {
        return BillingPeriod.Monthly;
    }
    return undefined;
}
// for redux (to be deprecated)
export function contributionTypeToBillingPeriod(contributionType) {
    switch (contributionType) {
        case 'ONE_OFF':
            return BillingPeriod.OneTime;
        case 'MONTHLY':
            return BillingPeriod.Monthly;
        case 'ANNUAL':
            return BillingPeriod.Annual;
    }
}
